import { APP_RESIZE, APP_HOMEINFO } from '../actions/appActions'

const initialState = {
    contentHeight:0,
    encoursProduits: [],
    encoursEnseigne: [],
    encoursWex :0,
    nomCommercial: '',
    telCommercial: '',
    plafond: 0,
    emailCommercial: '',
    url: '',
    parrain:''
}

const app = (state = initialState, action)=> {
    switch (action.type) {
        case APP_RESIZE: {
            const { contentHeight} = action.payload;
            
            return {
                ...state,
                contentHeight:contentHeight 
              }
        }

        case APP_HOMEINFO: {
            const  data = action.payload;
            return {
                ...state,
               ...data 
              }
        }
        
        default:
            return state;
    }

}

export default app